import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { httpAction } from '@/api/manage';
import { queryIdTree } from '@/api/api';
import pick from 'lodash.pick';
import ATextarea from 'ant-design-vue/es/input/TextArea';
export default {
  name: "SysDepartModal",
  components: {
    ATextarea: ATextarea
  },
  data: function data() {
    return {
      departTree: [],
      orgTypeData: [],
      phoneWarning: '',
      departName: "",
      title: "操作",
      seen: false,
      visible: false,
      condition: true,
      disableSubmit: false,
      model: {},
      menuhidden: false,
      menuusing: true,
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        departName: {
          rules: [{
            required: true,
            message: '请输入机构/部门名称!'
          }]
        },
        orgCode: {
          rules: [{
            required: true,
            message: '请输入机构编码!'
          }]
        },
        mobile: {
          rules: [{
            validator: this.validateMobile
          }]
        }
      },
      url: {
        add: "/sysdepart/sysDepart/add"
      }
    };
  },
  created: function created() {},
  methods: {
    loadTreeData: function loadTreeData() {
      var that = this;
      queryIdTree().then(function (res) {
        if (res.success) {
          that.departTree = [];

          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.departTree.push(temp);
          }
        }
      });
    },
    add: function add(depart) {
      if (depart) {
        this.seen = false;
      } else {
        this.seen = true;
      }

      this.edit(depart);
    },
    edit: function edit(record) {
      var _this = this;

      this.form.resetFields();
      this.model = Object.assign({}, {});
      this.visible = true;
      this.loadTreeData();
      this.model.parentId = record != null ? record.toString() : null;
      this.$nextTick(function () {
        _this.form.setFieldsValue(pick(_this.model, 'departName', 'departNameEn', 'departNameAbbr', 'departOrder', 'description', 'orgType', 'orgCode', 'mobile', 'fax', 'address', 'memo', 'status', 'delFlag'));
      });
    },
    close: function close() {
      this.$emit('close');
      this.disableSubmit = false;
      this.visible = false;
    },
    handleOk: function handleOk() {
      var _this2 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var formData = Object.assign(_this2.model, values); //时间格式化

          console.log(formData);
          httpAction(_this2.url.add, formData, "post").then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.loadTreeData();
              that.$emit('ok');
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    handleCancel: function handleCancel() {
      this.close();
    },
    validateMobile: function validateMobile(rule, value, callback) {
      if (!value || new RegExp(/^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/).test(value)) {
        callback();
      } else {
        callback("您的手机号码格式不正确!");
      }
    }
  }
};